<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.APPROVAL.POPUP.TITLE') }}</i>
                    </dt>
                    <dd>
                        <table class="create_table noLine">
                            <colgroup>
                                <col width="154px" />
                                <col class="*" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.SUBJECT') }}<em class="txt_mandatory">*</em></th>
                                    <td>
                                        <span class="clearable">
                                            <input
                                                type="text"
                                                class="text_input w100p"
                                                v-clearable
                                                v-model="approvalSubject"
                                            />
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.APPROVAL.POPUP.CLASS3') }}</th>
                                    <td>
                                        <fieldset class="ui_fieldset">
                                            <label class="serach-wrap w40p">
                                                <input
                                                    type="text"
                                                    class="text_input"
                                                    v-model="emailAddressesCL3"
                                                    @keyup.enter.stop="emailAddressFind(emailAddressesCL3, 'CL3','SEARCH')"
                                                />
                                                <a
                                                    href="javascript:"
                                                    class="in_btn_search"
                                                    @click="emailAddressFind(emailAddressesCL3, 'CL3','SEARCH')"
                                                >
                                                    <i class="ico_input_serach"></i>
                                                    <span class="sr_only"></span>
                                                </a>
                                            </label>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        {{ $t('FIELD.APPROVAL.POPUP.APPROVELIST') }}<em class="txt_mandatory">*</em>
                                    </th>
                                    <td>
                                        <fieldset class="ui_fieldset">
                                            <label class="serach-wrap w40p">
                                                <input
                                                    type="text"
                                                    class="text_input"
                                                    v-model="emailAddresses"
                                                    @keyup.enter.stop="emailAddressFind(emailAddresses, '','SEARCH')"
                                                />
                                                <a
                                                    href="javascript:"
                                                    class="in_btn_search"
                                                    @click="emailAddressFind(emailAddresses, '','SEARCH')"
                                                >
                                                    <i class="ico_input_serach"></i>
                                                    <span class="sr_only"></span>
                                                </a>
                                            </label>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr class="noLine">
                                    <td colspan="2">
                                        <dl class="approve_wrap">
                                            <dt>
                                                <fieldset class="radio-items">
                                                    <div>
                                                        <input
                                                            id="b10"
                                                            class="only-sr checked"
                                                            type="radio"
                                                            name="temp0"
                                                            value="1"
                                                            v-model="checkApproval"
                                                            @click="pathModify('approval')"
                                                        />
                                                        <label for="b10" :style="getApprovalStyle()" >{{ $t('TITLE.GLOBAL.APPROVAL') }}</label>
                                                    </div>
                                                    <div>
                                                        <input
                                                            id="b20"
                                                            class="only-sr"
                                                            type="radio"
                                                            name="temp0"
                                                            value="2"
                                                            v-model="checkApproval"
                                                            @click="pathModify('consent')"
                                                        />
                                                        <label for="b20" :style="getConsentStyle()"  >{{ $t('TITLE.GLOBAL.CONSENT') }}</label>
                                                    </div>
                                                    <div>
                                                        <input
                                                            id="b30"
                                                            class="only-sr"
                                                            type="radio"
                                                            name="temp0"
                                                            value="9"
                                                            v-model="checkApproval"
                                                            @click="pathModify('notification')"
                                                        />
                                                        <label for="b30" :style="getNotificationStyle()" >{{ $t('TITLE.GLOBAL.NOTIFICATION') }}</label>
                                                    </div>
                                                    
                                                    <div>
                                                        <input
                                                            id="b40"
                                                            class="only-sr"
                                                            type="radio"
                                                            name="temp0"
                                                            @click="pathModify('parallelApproval')"
                                                            :disabled = "isDisable"
                                                        />
                                                        <label for="b40" :style="{backgroundColor: isDisable ? '#fff':'#b3b3b3',color:isDisable?'#b3b3b3':'#fff'}" >{{ $t('TITLE.GLOBAL.PARALLELAPPROVAL') }}</label>
                                                    </div>
                                                    <div>
                                                        <input
                                                            id="b50"
                                                            class="only-sr"
                                                            type="radio"
                                                            name="temp0"
                                                            @click="pathModify('parallelConsent')"
                                                            :disabled = "isDisable"
                                                        />
                                                        <label for="b50" :style="{backgroundColor: isDisable ? '#fff':'#b3b3b3',color:isDisable?'#b3b3b3':'#fff'}"  >{{ $t('TITLE.GLOBAL.PARALLELCONSENT') }}</label>
                                                    </div>
                                                    <div>
                                                        <input
                                                            id="b60"
                                                            class="only-sr"
                                                            type="radio"
                                                            name="temp0"
                                                            @click="pathModify('relieve')"
                                                            :disabled = "isDisable"
                                                        />
                                                        <label for="b60" :style="{backgroundColor: isDisable ? '#fff':'#b3b3b3',color:isDisable?'#b3b3b3':'#fff'}">{{ $t('TITLE.GLOBAL.RELIEVE') }}</label>
                                                    </div>
                                                </fieldset>
                                                <article class="app_btn">
                                                    <span class="button-ctrl_first" @click="pathMove('first')"></span>
                                                    <span class="button-ctrl_prev" @click="pathMove('prev')"></span>
                                                    <span class="button-ctrl_next" @click="pathMove('next')"></span>
                                                    <span class="button-ctrl_last" @click="pathMove('last')"></span>
                                                    <span class="button-ctrl_del" @click="pathModify('delete')"></span>
                                                </article>
                                            </dt>
                                            <dd class="scroll">
                                                <ul>
                                                    <li
                                                        :class="item.aplnActive"
                                                        :id="item.aplSort"
                                                        :style=" 'DefaultAplnUser' == item.enDiscription ? 'pointer-events: none' : '' "
                                                        v-for="item in approvalPath"
                                                        :key="item.aplSort + approvalPathKey"
                                                        @click="getActive($event, 'li', item.aplSort, item.aplnRole)"
                                                    >
                                                        <fieldset class="radio-items" style ="width:100%" v-if="'0' === item.aplnRole  || '4' === item.aplnRole ||'7' === item.aplnRole ">
                                                            
                                                            <div v-if = "'0' === item.aplnRole">
                                                                <input
                                                                    class="only-sr"
                                                                    type="radio"
                                                                    :id="'radio0_' + item.aplnSeq"
                                                                    :name="'radio_' + item.aplnSeq"
                                                                    :checked="getChecked('0', item.aplnRole)"
                                                                />
                                                                <label :for="'radio0_' + item.aplSort">
                                                                    {{ $t('BUTTON.GLOBAL.REGISTER') }}
                                                                </label>
                                                                
                                                            </div>
                                                            
                                                             <div v-if = "'4' === item.aplnRole">
                                                                <input
                                                                    class="only-sr"
                                                                    type="radio"
                                                                    :id="'radio4_' + item.aplSort"
                                                                    :name="'radio_' + item.aplSort"
                                                                    :checked="getChecked('4', item.aplnRole)"
                                                                />
                                                                <label :for="'radio4_' + item.aplSort">
                                                                   	{{ $t('TITLE.GLOBAL.PARALLELCONSENT') }}
                                                                </label>
                                                            </div>
                                                            
                                                             <div v-if = "'7' === item.aplnRole">
                                                                <input
                                                                    class="only-sr"
                                                                    type="radio"
                                                                    :id="'radio7_' + item.aplSort"
                                                                    :name="'radio_' + item.aplSort"
                                                                    :checked="getChecked('7', item.aplnRole)"
                                                                />
                                                                <label :for="'radio7_' + item.aplnSort">
                                                                    {{ $t('TITLE.GLOBAL.PARALLELAPPROVAL') }}
                                                                </label>
                                                            </div>
                                                        </fieldset>
                                                        
                                                     
                                                        <fieldset class="radio-items" v-else >
                                                            <div>
                                                                <input
                                                                    class="only-sr"
                                                                    type="radio"
                                                                    value="1"
                                                                    :id="'radio1_' + item.aplSort"
                                                                    :name="'radio_' + item.aplSort"
                                                                    :checked="getChecked('1', item.aplnRole)"
                                                                    @click="
                                                                        getActive(
                                                                            $event,
                                                                            'input',
                                                                            item.aplSort,
                                                                            item.aplnRole,
                                                                        )
                                                                    "
                                                                />
                                                                <label :for="'radio1_' + item.aplSort">
                                                                    {{ $t('TITLE.GLOBAL.APPROVAL') }}
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <input
                                                                    class="only-sr"
                                                                    type="radio"
                                                                    value="2"
                                                                    :id="'radio2_' + item.aplSort"
                                                                    :name="'radio_' + item.aplSort"
                                                                    :checked="getChecked('2', item.aplnRole)"
                                                                    @click="
                                                                        getActive(
                                                                            $event,
                                                                            'input',
                                                                            item.aplSort,
                                                                            item.aplnRole,
                                                                        )
                                                                    "
                                                                />
                                                                <label :for="'radio2_' + item.aplSort">
                                                                    {{ $t('TITLE.GLOBAL.CONSENT') }}
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <input
                                                                    class="only-sr"
                                                                    type="radio"
                                                                    value="9"
                                                                    :id="'radio9_' + item.aplSort"
                                                                    :name="'radio_' + item.aplSort"
                                                                    :checked="getChecked('9', item.aplnRole)"
                                                                    @click="
                                                                        getActive(
                                                                            $event,
                                                                            'input',
                                                                            item.aplSort,
                                                                            item.aplnRole,
                                                                        )
                                                                    "
                                                                />
                                                                <label :for="'radio9_' + item.aplSort">
                                                                    {{ $t('TITLE.GLOBAL.NOTIFICATION') }}
                                                                </label>
                                                            </div>
                                                        </fieldset>
                                                        <span>
                                                            <em class="user ellipsis" :title="item.enFullName">
                                                                {{ item.enFullName }}
                                                            </em>
                                                            <em class="ellipsis" :title="item.enTitleName">
                                                                . <!-- {{ item.enTitleName }} -->
                                                            </em>
                                                            <em class="ellipsis" :title="item.enDepartmentName">
                                                                {{ item.enDepartmentName }}
                                                            </em>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </dd>
                                        </dl>
                                    </td>
                                </tr>
                                <tr class="noLine">
                                    <th>{{ $t('FIELD.GLOBAL.OPINION') }}<em class="txt_mandatory">*</em></th>
                                    <td><textarea class="text_textarea w100p" v-model="approvalOption"></textarea></td>
                                </tr>
                            </tbody>
                        </table>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine mt-0">
                            <div class="btn_right text-right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">
                                    {{ $t('BUTTON.GLOBAL.CANCEL') }}
                                </a>
                                <a href="javascript:" class="btn_blue" @click="save()">
                                    {{ $t('BUTTON.APPROVAL.POPUP.APPROVE') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import $ from 'jquery';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';

import DuplicationApprovalPopup from '~c/popup/DuplicationApprovalPopup';

let reg_email = /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

export default {
    name: 'AnysvcApprovalPopup',
    props: {
        rtnFunc: { type: Function },
        workTable: '',
        workColumn: '',
        workKey: '',
        firstApprovalYn: { default: 'N' },
        title: '',
        guideType: '',
        prdCategoryCd1: '',
        serviceBulletinYn: '',
    },
    watch: {
        approvalPath() {
            this.emailAddressesCL3 = '';
            this.emailAddresses = '';
        },
    },
    data() {
        return {
            approvalSubject: '',
            approvalOption: '',
            emailAddressesCL3: '',
            emailAddresses: '',
            approvalPath: [],
            checkApproval: '1',
            approvalPathKey: 0,
            guideTypeIf: '',
            prdCategoryCd1If: '',
            getServiceBulletinYn: '',
            isDisable:true,
            parallelApproval:[],
            parallelConsent:[],
            
        };
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
        }),
        getUserInfo() {
            return SDLUtil.getLoginedUserInfo() || {};
        },
        getUserRole() {
            return this.userRoles || [];
        },
        getUserCorpCd() {
            return this.userCorpCd || '';
        },
    },
    mounted() {
        this.approvalSubject = this.title;
        this.emailAddressFind('', '0');
        this.guideTypeIf = this.guideType;
        this.prdCategoryCd1If = this.prdCategoryCd1;
        this.getServiceBulletinYn = this.serviceBulletinYn;
    },
    methods: {
        async emailAddressFind(v, aplnRole,flag) {
            let email = v;
            if ('0' === aplnRole) {
                email = JSON.parse(localStorage.getItem('loginUser')).email;
                if (SDLUtil.isNull(await this.emailAddressCheck(email, aplnRole))) {
                    SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.KNOX.EMAIL.CONFIRM'));
                    return this.$emit('close');
                }
                if ((this.prdCategoryCd1 === 'D') && this.serviceBulletinYn === 'SB') {
                	this.getAgreementUser();
                }
                
            } else {
                if (SDLUtil.isNull(await this.emailAddressCheck(email, aplnRole,flag))) {
                    if ('CL3' === aplnRole) {
                        SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.KNOX.EMAIL.NOFOUND.CL3'));
                    } else {
                        SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.KNOX.EMAIL.NOFOUND'));
                    }
                }
            }
        },
        async getAgreementUser() {
		    //search from   prdCategoryCd1 (VD/DA)  guideType (a)
      try {
          const resp = await axios.post(
              `${SDLUtil.API_URL}/basis/approval/defaultMXAgreementUser.skp`,
              qs.stringify({prdCategoryCd1: this.prdCategoryCd1,guideType: this.guideType,}));

          const result = resp.data.result;
          for(const item of result.rowData){
            let emailDefaultUser =  item.EMAIL;      //email
            let defaultAplnRole =  item.APIN_ROLE;   //apln role
            if (SDLUtil.isNull(await this.emailAddressCheck(emailDefaultUser, defaultAplnRole))) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.KNOX.EMAIL.CONFIRM'));
                return this.$emit('close');
            }
          }
      } catch (err) {
          Vue.$log.error(err);
          SDLUtil.errorAlert(err);
          SDLUtil.showLoadingBar(false);
      }
    },
        async emailAddressCheck(v, aplnRole,flag) {
            let searchFullName = '';
            let searchEmailAddresses = '';

            if (reg_email.test(v)) {
                searchEmailAddresses = v;
            } else {
                searchFullName = v;
            }

            if ('0' !== aplnRole && !SDLUtil.isNull(searchEmailAddresses)) {
                if (0 > searchEmailAddresses.indexOf('samsung.com') && 'TN_TOOL_MANAGER' === this.workTable) {
                    return this.approvalPathCheck(0, searchEmailAddresses);
                }
            }

            SDLUtil.showLoadingBar(true);
            try{
                const resp = await axios.post(`${SDLUtil.API_URL}/basis/approval/handleSelect.skp`,
                    qs.stringify({fullName: searchFullName,emailAddresses: searchEmailAddresses,}))
                    let result = JSON.parse(resp.data.result);
                    if (!SDLUtil.isNull(result.employees) && 0 < result.employees.length && 'CL3' === aplnRole) {
                        for (let index = 0; index < result.employees.length; index++) {
                            const idx = result.employees.findIndex(function(item) {
                                return 0 > item.titleCode.indexOf(aplnRole);
                            });
                            if (-1 < idx) {
                                result.employees.splice(idx, 1);
                            } else {
                                break;
                            }
                        }
                    }

                    if (!SDLUtil.isNull(result.employees) && 0 < result.employees.length) {
                        if ('0' === aplnRole) {
                            this.approvalPath = [];
                            for (const iterator of result.employees) {
                                if (0 === this.approvalPath.length) {
                                    iterator.aplnRole = aplnRole;
                                    iterator.aplnSeq = this.approvalPath.length;
                                    iterator.aplSort = this.approvalPath.length;
                                    iterator.aplnActive = '';
                                    this.approvalPath.push(iterator);
                                }
                            }
                        } else if (1 === result.employees.length) {
                            for (const iterator of result.employees) {
                            	if((this.prdCategoryCd1 === 'D' || this.prdCategoryCd1 === 'C') && 'SEARCH' != flag){
                            		iterator.aplnRole = aplnRole;
                            		iterator.enDiscription = 'DefaultAplnUser';
                            	}else{
                            		iterator.aplnRole = this.checkApproval;
                            	}
								iterator.aplnSeq = this.approvalPath.length;
								iterator.aplSort = this.approvalPath.length;
                                iterator.aplnActive = '';
                                const idx = this.approvalPath.findIndex(function(item) {
                                    if ('0' !== item.aplnRole) {
                                        return item.emailAddress === iterator.emailAddress;
                                    } else {
                                        return false;
                                    }
                                });
                                if (0 > idx) {
                                    this.approvalPath.push(iterator);
                                }
                            }
                        } else {
                            // 동명 이인 팝업 실행
                            SDLUtil.showLoadingBar(false);
                            this.duplicationApprovalPopup(result.employees, aplnRole, v);
                        }
                    }
                    SDLUtil.showLoadingBar(false);
                    return result.employees;
            } catch (err){
                Vue.$log.error(err);
                SDLUtil.errorAlert(err);
                SDLUtil.showLoadingBar(false);
            }
        },
        save() {
        	const parallelApprovalData = this.approvalPath.filter((item,index) => item.aplnRole === '7');
			const parallelConsentData= this.approvalPath.filter((item,index) => item.aplnRole === '4');
			if(parallelApprovalData.length > 0){
        		if(parallelApprovalData.length === 1 ){
        			SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.APPROVAL.SAVE.APPROVER.CHECK'));
        			return;
        		} 
			}
			if(parallelConsentData.length > 0){
        		if(parallelConsentData.length === 1 ){
       		 		SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.APPROVAL.SAVE.CONSULTATION.CHECK'));
       				return;
       			}
			}
            SDLUtil.showLoadingBar(true);
            this.pathSeq();
            let MENDATORY = SDLUtil.getMsgProp('MESSAGE.FIELD.CHECK.MENDATORY');
            let idx = -1;
            if(this.getServiceBulletinYn === 'SB') {
            	idx = this.approvalPath.findIndex(function(item) {
        			return item.aplnRole === '2' || item.aplnRole === '4';
        			});
            } else {
            	idx = this.approvalPath.findIndex(function(item) {
            		return item.aplnRole === '1';
            	});
            }
            
            if (0 > idx ) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.APPROVAL.POPUP.APPROVELIST')));
                SDLUtil.showLoadingBar(false);
                return false;
            } else if (SDLUtil.isNull(this.approvalSubject)) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT')));
                SDLUtil.showLoadingBar(false);
                return false;
            } else if (SDLUtil.isNull(this.approvalOption)) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.APPROVAL.POPUP.APPROVEOPTION')));
                SDLUtil.showLoadingBar(false);
                return false;
            }

            for (const element of this.approvalPath) {
                if (
                    element.aplnRole === '0' &&
                    element.emailAddress != JSON.parse(localStorage.getItem('loginUser')).email
                ) {
                    element.emailAddress = JSON.parse(localStorage.getItem('loginUser')).email;
                }
            }

            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/approval/handleSave.skp`,
                    qs.stringify({
                        aplnSubject: this.approvalSubject,
                        aplnContents: this.approvalOption,
                        workTable: this.workTable,
                        workColumn: this.workColumn,
                        workKey: this.workKey,
                        firstApprovalYn: this.firstApprovalYn,
                        contentsType: 'HTML',
                        approvalPath: JSON.stringify(this.approvalPath),
                    }),
                )
                .then(resp => {
                    SDLUtil.alert(resp.data.msg);
                    SDLUtil.showLoadingBar(false);
                    this.$router.push({name: 'hhpServiceBulletin'});
                    this.rtnFunc(resp.data.result.rowData);
                    return this.$emit('close');
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
            
        },
        getActive(e, v, aplSort, aplnRole) {
            if ('0' === aplnRole) {
            } else if ('li' === v) {
                if ('active' === this.approvalPath[aplSort].aplnActive) {
                   // this.approvalPath[aplSort].aplnActive = '';
                   	this.$set(this.approvalPath[aplSort],'aplnActive',''); 
                   	this.$forceUpdate();
                } else {
                    //this.approvalPath[aplSort].aplnActive = 'active';
                    this.$set(this.approvalPath[aplSort],'aplnActive','active');
                    this.$forceUpdate();
                }
            } else if ('input' === v) {
                if (SDLUtil.isNull(this.approvalPath[aplSort].epId)) {
                    return this.approvalPathKey++;
                }
                this.approvalPath[ aplSort].aplnRole = $(e.target).val();
            
           }
            const changeData = this.approvalPath.filter((item,index) => item.aplnActive === 'active').map(item => item.aplnActive);
            if(changeData.length > 1){
            	this.isDisable = false;
            }else{
            	this.isDisable = true;
            }
        },
        getChecked(v1, v2) {
            let result = false;
            if (v1 === v2) result = true;
            return result;
        },
        approvalPathCheck(i, v) {
            const path = {
                enDiscription: '',
                epId: '',
                employeeStatus: '',
                titleCode: '',
                employeeNumber: '',
                enCompanyName: '',
                userId: '',
                enTitleName: '',
                enDepartmentName: '',
                aplnActive: '',
                enFullName: v,
                emailAddress: v,
                aplnRole: '9',
                aplnSeq: this.approvalPath.length,
                aplSort: this.approvalPath.length,
            };
            const idx = this.approvalPath.findIndex(function(item) {
                return item.emailAddress === v;
            });
            if (0 > idx) {
                this.approvalPath.push(path);
            }
            return this.approvalPath;
        },
        pathModify(v) {
        	const changeData = this.approvalPath.filter((item,index) => item.aplnActive === 'active').map(item => item.aplnActive);
        	
        	if('parallelApproval' === v || 'parallelConsent' === v){     		
        	if(changeData.length <= 1){
        		SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.APPROVAL.PARALLEL.CHECK'));
        		return;
        	} 	
        }
        	if('relieve' === v){
        		const changeData = this.approvalPath.filter((item,index) => item.aplnActive === 'active').map(item => item.aplnRole);
        		const typeList = changeData.filter((item,index) => changeData.indexOf(item) === index);
        		if(typeList.length > 1 ){
        			SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.APPROVAL.RELIEVE.CHECK'));
        			return;
        		}
        	}
        	
        	
            for (let index = 0; index < this.approvalPath.length; index++) {
                const idx = this.approvalPath.findIndex(function(item) {
                    return item.aplnActive === 'active';
                });
                if (-1 < idx) {
                    if ('delete' === v) {
                        this.approvalPath.splice(idx, 1);
                    } else if ('approval' === v) {
                    	if(this.approvalPath[idx].aplnRole === '4' || this.approvalPath[idx].aplnRole === '7'){
                    		SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.APPROVAL.SWITCH.CHECK'));
                			return;
                    	}
                        if (!SDLUtil.isNull(this.approvalPath[idx].epId)) {
                            this.approvalPath[idx].aplnRole = '1';
                        }
                        this.approvalPath[idx].aplnActive = '';
                    } else if ('consent' === v) {
                    	if(this.approvalPath[idx].aplnRole === '4' || this.approvalPath[idx].aplnRole === '7'){
                    		SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.APPROVAL.SWITCH.CHECK'));
                			return;
                    	}
                        if (!SDLUtil.isNull(this.approvalPath[idx].epId)) {
                            this.approvalPath[idx].aplnRole = '2';
                        }
                        this.approvalPath[idx].aplnActive = '';
                    } else if ('notification' === v) {
                    	if(this.approvalPath[idx].aplnRole === '4' || this.approvalPath[idx].aplnRole === '7'){
                    		SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.APPROVAL.SWITCH.CHECK'));
                			return;
                    	}
                        this.approvalPath[idx].aplnRole = '9';
                        this.approvalPath[idx].aplnActive = '';
                    }else if ('parallelConsent' === v) {
                        this.approvalPath[idx].aplnRole = '4';
                        this.approvalPath[idx].aplnActive = '';
                        this.isDisable = true;
                    } else if ('parallelApproval' === v) {
                        this.approvalPath[idx].aplnRole = '7';
                        this.approvalPath[idx].aplnActive = ''; 
                        this.isDisable = true;
                    } else if ('relieve' === v) {
                        if(this.approvalPath[idx].aplnRole === '4'){
                        	 if (!SDLUtil.isNull(this.approvalPath[idx].epId)) {
                                 this.approvalPath[idx].aplnRole = '2';
                             }
                        	this.checkApproval='2';
                            this.approvalPath[idx].aplnActive = '';
                        }
                        if(this.approvalPath[idx].aplnRole === '7'){
                        	 if (!SDLUtil.isNull(this.approvalPath[idx].epId)) {
                                 this.approvalPath[idx].aplnRole = '1';  
                             }
                        	this.checkApproval='1';
                            this.approvalPath[idx].aplnActive = '';
                        }
                        
                        this.isDisable = true;
                    }
                } else {
                    break;
                }
            }

            if ('delete' === v) {
                this.pathSeq();
            }
            this.pathSeq();
            
        },
        pathMove(v) {
            let newApprovalPath = JSON.parse(JSON.stringify(this.approvalPath));
            if (['first', 'next'].includes(v)) {
                newApprovalPath.reverse();
            }

            let min = newApprovalPath.length - 2;

            for (let index = 0; index < newApprovalPath.length; index++) {
                const idx = newApprovalPath.findIndex(function(item) {
                    return item.aplnActive === 'active';
                });

                if (-1 < idx) {
                    let path = newApprovalPath[idx];
                    path.aplnActive = '';
                    newApprovalPath.splice(idx, 1);

                    if ('first' === v) {
                        newApprovalPath.splice(min, 0, path);
                    } else if ('prev' === v) {
                    	if(newApprovalPath[idx - 1].aplnRole === '4' ){
                    	const parallelConsentLength = newApprovalPath.filter((item,index) => item.aplnRole === '4' );
                		newApprovalPath.splice(0 < idx - parallelConsentLength.length ? idx - parallelConsentLength.length : parallelConsentLength.length, 0, path);
                    	} else if (newApprovalPath[idx - 1].aplnRole === '7'){
                    		const parallelApproveLength = newApprovalPath.filter((item,index) => item.aplnRole === '7' );
                    		newApprovalPath.splice(0 < idx - parallelApproveLength.length ? idx - parallelApproveLength.length : parallelApproveLength.length, 0, path);
                    	}else{
                    		newApprovalPath.splice(0 < idx - 1 ? idx - 1 : 1, 0, path);
                    	}
                    } else if ('next' === v) {
                        if (0 > idx) {
                            newApprovalPath.splice(min < idx - 1 ? min : idx - 1, 0, path);
                        } else {
                            newApprovalPath.unshift(path);
                        }
                    } else if ('last' === v) {
                        newApprovalPath.push(path);
                    }
                } else {
                    break;
                }
            }

            if (['first', 'next'].includes(v)) {
                newApprovalPath.reverse();
            }

            this.approvalPath = newApprovalPath;
            this.pathSeq();
        },
        pathSeq() {
            this.parallelConsent = [];
            this.parallelApproval = [];
            for(let index = 0; index < this.approvalPath.length; index++){
            	if(this.approvalPath[index].aplnRole === '4'){
            		this.parallelConsent.push(this.approvalPath[index]);
            	}
            	if(this.approvalPath[index].aplnRole === '7'){
            		this.parallelApproval.push(this.approvalPath[index]);
            	}
            	
            }
            
            let cnt = 0;
            let  newApprPath=[];
            for(let index = 0; index < this.approvalPath.length; index++){
            	let newApprPathIndex = 0;
				if(this.approvalPath[index].aplnRole === "4"){
					cnt = cnt++;
					for(let parallelConsentIndex = 0; parallelConsentIndex < this.parallelConsent.length; parallelConsentIndex++){
						this.parallelConsent[parallelConsentIndex].aplnSeq = cnt;
						newApprPath.push(this.parallelConsent[parallelConsentIndex]);
					}
					if( this.parallelConsent.length > 0){cnt++}
					 this.parallelConsent = [];
            	} else if (this.approvalPath[index].aplnRole === "7"){
            		cnt = cnt++;
					for(let parallelApprovalIndex = 0; parallelApprovalIndex < this.parallelApproval.length; parallelApprovalIndex++){
						this.parallelApproval[parallelApprovalIndex].aplnSeq = cnt;						
						newApprPath.push(this.parallelApproval[parallelApprovalIndex]);
					}
					if(this.parallelApproval.length > 0){cnt++}
					 this.parallelApproval = [];
            	} else {
            		this.approvalPath[index].aplnSeq = cnt++;
            		newApprPath.push(this.approvalPath[index]);
            	}
            }
            for(let newApprPathIndex = 0; newApprPathIndex < newApprPath.length; newApprPathIndex++){
            	newApprPath[newApprPathIndex].aplSort=newApprPathIndex;
            }
            this.approvalPath = newApprPath;
        },
        
        duplicationApprovalPopup(propsPath, aplnRole, searchName) {
            let newApprovalPath = JSON.parse(JSON.stringify(this.approvalPath));
            SDLUtil.show(
                DuplicationApprovalPopup,
                {
                    propsPath: propsPath,
                    propsApprovalPath: newApprovalPath,
                    propsAplnRole: aplnRole,
                    propsSearchName: searchName,
                    rtnFunc: v => {
                        v.aplnRole = this.checkApproval;
                        v.aplnSeq = this.approvalPath.length;
                        v.aplSort = this.approvalPath.length;
                        v.aplnActive = '';

                        const idx = this.approvalPath.findIndex(function(item) {
                            if ('0' !== item.aplnRole) {
                                return item.emailAddress === v.emailAddress;
                            } else {
                                return false;
                            }
                        });
                        if (0 > idx) {
                            this.approvalPath.push(v);
                        }
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        
        getApprovalStyle(){
        	if(this.checkApproval === '1' ){
        		return {backgroundColor:'#578be2',color:'#fff'};
        	} else {
        		return {backgroundColor:'#b3b3b3',color:'#fff'};	
        	}
        	
        },
        getConsentStyle(){
        	if(this.checkApproval === '2'){
        		return {backgroundColor:'#578be2',color:'#fff'};
        	} else {
        		return {backgroundColor:'#b3b3b3',color:'#fff'};	
        	}
        	
        },
        
        getNotificationStyle(){
        	if(this.checkApproval === '9'){
        		return {backgroundColor:'#578be2',color:'#fff'};
        	} else {
        		return {backgroundColor:'#b3b3b3',color:'#fff'};	
        	}
        	
        },
        
    },
};
</script>

<style>
.text-right {
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/common/popup/AnysvcApprovalPopup.vue